export const CardInTransitUiEnabled = 'card_in_transit_ui_enabled'
export const UnifiedHomeIndex = 'unified_home_index'
export const UseNewMortgageSection = 'home_-_use_new_mortgage_section'
